import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumStockAdjustDutyImplication implements BaseEnumType {
  private static allValues: EnumStockAdjustDutyImplication[] = []; // make sure this is top-most
  
  public static noDuty = new EnumStockAdjustDutyImplication(0, "NoDuty", "enum_stock_adjust_duty_implication_no_duty");
  public static dutiable = new EnumStockAdjustDutyImplication(1, "Dutiable", "enum_stock_adjust_duty_implication_dutiable");
  public static dutySuspended3rdParty = new EnumStockAdjustDutyImplication(2, "DutySuspended3rdParty", "enum_stock_adjust_duty_implication_duty_suspended3rd_party");
  public static produced = new EnumStockAdjustDutyImplication(3, "Produced", "enum_stock_adjust_duty_implication_produced");
  public static consumedOnPremisesNoDuty = new EnumStockAdjustDutyImplication(4, "ConsumedOnPremisesNoDuty", "enum_stock_adjust_duty_implication_consumed_on_premises_no_duty");
  public static destroyed = new EnumStockAdjustDutyImplication(5, "Destroyed", "enum_stock_adjust_duty_implication_destroyed");
  public static losses = new EnumStockAdjustDutyImplication(6, "Losses", "enum_stock_adjust_duty_implication_losses");
  public static theft = new EnumStockAdjustDutyImplication(7, "Theft", "enum_stock_adjust_duty_implication_theft");
  public static physicalStockCount = new EnumStockAdjustDutyImplication(8, "PhysicalStockCount", "enum_stock_adjust_duty_implication_physical_stock_count");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStockAdjustDutyImplication.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNoDuty() { return this === EnumStockAdjustDutyImplication.noDuty; }
  public isDutiable() { return this === EnumStockAdjustDutyImplication.dutiable; }
  public isDutySuspended3rdParty() { return this === EnumStockAdjustDutyImplication.dutySuspended3rdParty; }
  public isProduced() { return this === EnumStockAdjustDutyImplication.produced; }
  public isConsumedOnPremisesNoDuty() { return this === EnumStockAdjustDutyImplication.consumedOnPremisesNoDuty; }
  public isDestroyed() { return this === EnumStockAdjustDutyImplication.destroyed; }
  public isLosses() { return this === EnumStockAdjustDutyImplication.losses; }
  public isTheft() { return this === EnumStockAdjustDutyImplication.theft; }
  public isPhysicalStockCount() { return this === EnumStockAdjustDutyImplication.physicalStockCount; }

  public static getValues(): readonly EnumStockAdjustDutyImplication[] {
    return EnumStockAdjustDutyImplication.allValues;
  }

  public static getValuesExcept0(): readonly EnumStockAdjustDutyImplication[] {
    return EnumStockAdjustDutyImplication.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumStockAdjustDutyImplication {
    const found = EnumStockAdjustDutyImplication.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStockAdjustDutyImplication - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumStockAdjustDutyImplication): EnumStockAdjustDutyImplication {
    const found = name ? EnumStockAdjustDutyImplication.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumStockAdjustDutyImplication - Value not found: ${ name }`);
    }

    return found;
  }
}